/**
 * PlaceCoreVerifiedBadge — Discreet "Verifierad" badge for hero.
 */
import { BadgeCheck } from "lucide-react";

interface Props {
  hasCover?: boolean;
}

export function PlaceCoreVerifiedBadge({ hasCover }: Props) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-xs font-medium ${
        hasCover
          ? "text-white/80"
          : "text-primary/70"
      }`}
    >
      <BadgeCheck className="h-3.5 w-3.5" />
      Verifierad
    </span>
  );
}
